import { Modal, ModalHeader, ModalBody, ModalFooter } from './Modal'

interface ConfirmDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  confirmVariant?: 'primary' | 'danger'
  isProcessing?: boolean
  processingLabel?: string
  warningMessage?: string
}

export function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmVariant = 'primary',
  isProcessing = false,
  processingLabel = 'Processing...',
  warningMessage
}: ConfirmDialogProps) {
  return (
    <Modal 
      isOpen={isOpen} 
      onClose={isProcessing ? () => {} : onClose}
      preventCloseOnOverlay={isProcessing}
      size="small"
    >
      <ModalHeader 
        title={title} 
        onClose={onClose} 
        disabled={isProcessing}
      />
      <ModalBody>
        <p>{message}</p>
        {warningMessage && (
          <p style={{ marginTop: '1rem', fontSize: '0.9rem', color: 'var(--text-muted)' }}>
            {warningMessage}
          </p>
        )}
      </ModalBody>
      <ModalFooter>
        <button 
          onClick={onClose} 
          className="cancel-btn" 
          disabled={isProcessing}
        >
          {cancelLabel}
        </button>
        <button 
          onClick={onConfirm} 
          className={confirmVariant === 'danger' ? 'delete-btn' : 'submit-btn'}
          disabled={isProcessing}
        >
          {isProcessing ? processingLabel : confirmLabel}
        </button>
      </ModalFooter>
    </Modal>
  )
}
